import type { Appearance, CssFontSource } from '@stripe/stripe-js'

export const stripePaymentElementFonts: CssFontSource[] = [{
  cssSrc: 'https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600&display=swap'
}]

const stripePaymentElementAppearance: Appearance = {
  theme: 'flat',
  labels: 'above',
  variables: {
    fontFamily: 'Poppins, sans-serif',
    borderRadius: '0px',
    colorPrimaryText: '#000000',
    colorBackground: '#ffffff',
    iconCheckmarkColor: '#ffffff'
  },
  rules: {
    '.Input': {
      backgroundColor: 'rgba(0, 0, 0, 0.06)',
      borderRadius: '25px',
      fontSize: '14px',
      padding: '10px 20px',
      border: '0',
      outline: '0'
    },
    '.Input:focus': {
      boxShadow: 'none',
      outline: '0'
    },
    '.Input--invalid': {
      boxShadow: 'none',
      outline: '0',
      border: '0'
    },
    '.Label': {
      color: 'rgba(0, 0, 0, 0.6)',
      fontSize: '13.5px',
      fontWeight: '500',
      lineHeight: '1.2',
      marginBottom: '5px'
    },
    '.Label--focused': {
      color: '#00aced'
    },
    '.Label--invalid': {
      color: '#d32f2f'
    },
    '.CheckboxInput': {
      border: '1px solid #afafaf',
      borderRadius: '3px'
    },
    '.CheckboxInput--checked': {
      backgroundColor: '#000',
      borderColor: '#000'
    },
    '.Error': {
      fontSize: '.8rem'
    },
    '.Tab': {
      padding: '10px 12px 8px 12px',
      border: '1px solid #afafaf',
      borderRadius: '8px'
    },
    '.Tab:hover, .Tab:focus': {
      border: '1px solid #000',
      outline: 'none',
      boxShadow: '0px 1px 1px rgba(0, 0, 0, 0.03), 0px 3px 7px rgba(18, 42, 66, 0.04)'
    },
    '.Tab--selected, .Tab--selected:focus, .Tab--selected:hover': {
      border: '1px solid transparent',
      backgroundColor: '#fff',
      boxShadow: '0 0 0 1.5px #000, 0px 1px 1px rgba(0, 0, 0, 0.03), 0px 3px 7px rgba(18, 42, 66, 0.04)'
    }
  }
}

export default stripePaymentElementAppearance
